module.exports = __webpack_public_path__ + "img/T1_ty_14.ac53c12d.png";